import React from 'react';
import useAsrSettings from '../../../useSession/useAsrSettings';
import arrayBufferToBase64 from './utils/arrayBufferToBase64';
import { AudioConfig } from '../../../useAudioConfig';
import useAudioStream from '../../../../../Hooks/audio/useAudioStream';
import useAudioRecorder from '../../../../../Hooks/audio/useAudioRecorder';

export default function useAudioCapture(inProgress: boolean, audioConfig: AudioConfig) {
  const [lastAudioBlob, setLastAudioBlob] = React.useState<string | null>(null);
  const { enableCoreAsrApi: settingsEnabled } = useAsrSettings();

  const enabled = React.useMemo(() => inProgress && settingsEnabled, [inProgress, settingsEnabled]);
  const enabledRef = React.useRef(enabled);

  React.useEffect(() => {
    enabledRef.current = enabled;
  }, [enabled]);

  function callback(data: string) {
    if (enabledRef.current) {
      setLastAudioBlob(data);
    } else {
      setLastAudioBlob(null);
    }
  }

  const stream = useAudioStream(enabled, audioConfig);
  useAudioRecorder(stream, (data) => {
    callback(arrayBufferToBase64(data));
  });

  React.useEffect(() => {
    if (!enabled) {
      setLastAudioBlob(null);
    }
  }, [enabled]);

  return lastAudioBlob;
}
